import { render } from "./VipRules2.vue?vue&type=template&id=6bead83d&scoped=true"
import script from "./VipRules2.vue?vue&type=script&lang=js"
export * from "./VipRules2.vue?vue&type=script&lang=js"

import "./VipRules2.vue?vue&type=style&index=0&id=6bead83d&scoped=true&lang=css"
import "./VipRules2.vue?vue&type=style&index=1&id=6bead83d&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bead83d"]])

export default __exports__